<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100" v-show="!isShowBill">
      <md-card>
        <md-card-header class="dark-header">
          <h4 class="title">Lọc đơn và tìm kiếm</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item">
              <md-datepicker v-model="filter.startDate" :md-immediately="true">
                <label>Từ ngày:</label>
              </md-datepicker>
            </div>
            <div class="md-layout-item">
              <md-datepicker v-model="filter.endDate" :md-immediately="true">
                <label>Đến ngày:</label>
              </md-datepicker>
            </div>
            <div class="md-layout-item" v-if="pageMode === 'Báo cáo xuất hàng'">
              <md-field>
                <label>Trạng thái:</label>
                <md-select v-model="filter.status">
                  <md-option :value="-1">Tất cả</md-option>
                  <md-option :value="0">Đơn hàng mới</md-option>
                  <md-option :value="1">Đã xác nhận</md-option>
                  <md-option :value="2">Đang vận chuyển</md-option>
                  <md-option :value="3">Hoàn tất</md-option>
                  <md-option :value="4">Đã hủy</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item" v-else>
              <md-field>
                <label>Hính thức thanh toán:</label>
                <md-select v-model="filter.paymentMethod">
                  <md-option value="Thu tiền mặt">Thu tiền mặt</md-option>
                  <md-option value="Chuyển khoản">Chuyển khoản</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-autocomplete
                v-model="filter.salerName"
                :md-options="listSalerName"
                :md-open-on-focus="true"
                @md-selected="startFilter"
              >
                <label>Tên nhân viên</label>

                <template slot="md-autocomplete-empty" slot-scope="{ term }">
                  "{{ term }}" không tồn tại
                </template>
              </md-autocomplete>
            </div>
            <div class="md-layout-item">
              <md-autocomplete
                v-model="filter.customerName"
                :md-options="listCustomerName"
                :md-open-on-focus="true"
                @md-selected="startFilter"
              >
                <label>Tên khách hàng</label>

                <template slot="md-autocomplete-empty" slot-scope="{ term }">
                  "{{ term }}" không tồn tại
                </template>
              </md-autocomplete>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <div class="md-layout-item md-size-100" v-show="!isShowBill">
      <md-card>
        <md-card-header class="dark-header">
          <h4 class="title buttonAddBill">
            {{
              pageMode === "Báo cáo xuất hàng"
                ? "Danh sách đơn hàng"
                : "Danh sách thu"
            }}
          </h4>
          <!-- <md-button @click="updateAll">update all</md-button> -->
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-33 md-small-size-100">
              <md-field>
                <md-select v-model="pageMode">
                  <md-option value="Báo cáo xuất hàng"
                    >Báo cáo xuất hàng</md-option
                  >
                  <md-option value="Báo cáo thu">Báo cáo thu</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <div>
                <md-button @click="exportExcel" class="md-success md-dense"
                  >Xuất excel</md-button
                >
              </div>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-button class="md-dense md-success" @click="addNewBill"
                >Tạo đơn mới</md-button
              >
            </div>
          </div>
          <md-table
            v-model="queriedData"
            class="table-hover table-border billtable"
            table-header-color="green"
          >
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              :class="
                item.data.status == 4
                  ? 'danger'
                  : item.data.status == 1
                  ? 'success'
                  : item.data.status == 2
                  ? 'shipping'
                  : item.data.status == 3
                  ? 'done'
                  : ''
              "
              @click="showBillDetail(item)"
              class="clickable"
            >
              <md-table-cell
                md-label="ID"
                class="table-cell"
                align="left"
                md-clear="true"
                >{{ item.data.orderId }}</md-table-cell
              >
              <md-table-cell
                :md-label="
                  pageMode === 'Báo cáo thu' ? 'Ngày thu tiền' : 'Ngày đặt hàng'
                "
                class="table-cell"
                >{{ formatDate(new Date(item.data.orderDate)) }}
              </md-table-cell>
              <md-table-cell
                md-label="Khách hàng"
                class="table-cell"
                align="left"
                >{{ item.data.customerName }}</md-table-cell
              >
              <md-table-cell
                md-label="Người bán"
                class="table-cell"
                align="left"
                >{{ item.data.salerName }}</md-table-cell
              >
              <md-table-cell
                md-label="Người tạo đơn"
                class="table-cell"
                align="left"
                >{{
                  item.data.creator === "Admin"
                    ? item.data.creator
                    : item.data.salerName
                }}</md-table-cell
              >
              <md-table-cell
                md-label="Thành tiền"
                md-numeric
                class="table-cell table-cell-money"
                >{{
                  formatMoney(
                    pageMode === "Báo cáo xuất hàng"
                      ? item.data.amount
                      : item.data.amount * -1
                  )
                }}</md-table-cell
              >
              <md-table-cell
                md-label="Hình thức thanh toán"
                class="table-cell"
                >{{ item.data.paymentMethod }}</md-table-cell
              >
              <md-table-cell
                md-label="Thời hạn thanh toán"
                class="table-cell"
                >{{
                  item.data.paymentTime
                    ? formatDate(new Date(item.data.paymentTime))
                    : "-"
                }}</md-table-cell
              >
              <md-table-cell
                md-label="Trạng thái"
                class="table-cell"
                align="left"
              >
                {{
                  item.data.status == 0
                    ? "Đơn hàng mới"
                    : item.data.status == 1
                    ? "Đã xác nhận"
                    : item.data.status == 2
                    ? "Đang vận chuyển"
                    : item.data.status == 3
                    ? "Hoàn tất"
                    : "Đã hủy"
                }}
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">Hiển thị từ {{ from + 1 }} đến {{ to }}</p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
    <bill-detail
      :billSelected="billSelected"
      :db="db"
      :isAddBill="isAddBill"
      v-if="isShowBill"
      @close="close"
      @addBillClose="addBillClose"
    ></bill-detail>
  </div>
</template>
<script>
import firebase from "@/services/firebase-init.js";
import { mapGetters } from "vuex";
import { Pagination } from "@/components";
export default {
  components: {
    BillDetail: () => import("./BillDetail"),
    Pagination,
  },
  mounted() {
    this.db = firebase.firestore();
    this.getData(null, null, this.pagination.perPage * 2);
    let bits = localStorage.getItem("bits");
    this.db
      .collection(process.env.VUE_APP_USER + bits)
      .get()
      .then((doc) => {
        doc.forEach((item) => {
          this.listSalerName.push(item.data().name);
        });
      });
    this.db
      .collection("--stats--")
      .doc(process.env.VUE_APP_LIST_CUSTOMER + bits)
      .get()
      .then((doc) => {
        doc.data().listCustomer.forEach((item) => {
          this.listCustomerName.push(item.customerName);
        });
      });
  },
  data() {
    return {
      isAddBill: false,
      pageMode: "Báo cáo xuất hàng",
      db: {},
      listSalerName: ["Admin"],
      listCustomerName: [],
      listBill: [],
      idSelected: Number,
      billSelected: {},
      isShowBill: false,
      filter: {
        startDate: null,
        endDate: null,
        status: 0,
        salerName: "",
        customerName: "",
        paymentMethod: "Thu tiền mặt",
      },
      pagination: {
        currentPage: 1,
        perPage: 100,
      },
    };
  },
  methods: {
    startFilter() {
      this.listBill = [];
      this.getData(null, null, this.pagination.perPage * 2);
      this.pagination.currentPage = 1;
    },

    addNewBill() {
      (this.isAddBill = true), (this.isShowBill = true);
    },

    getClass: ({ id }) => ({
      "md-primary": id === 2,
      "md-accent": id === 3,
    }),

    showBillDetail(item) {
      if (item && this.pageMode === "Báo cáo xuất hàng") {
        this.isShowBill = true;
        this.billSelected = item;
      }
    },

    async exportCollection() {
      const tHeader = Object.values(
        this.filter.paymentMethod === "Thu tiền mặt"
          ? this.AllFieldDataCashReceipts
          : this.AllFieldDataBankReceipts
      );
      const filterVal = Object.keys(
        this.filter.paymentMethod === "Thu tiền mặt"
          ? this.AllFieldDataCashReceipts
          : this.AllFieldDataBankReceipts
      );
      this.listBill = [];
      await this.getData();
      this.$exportExcel(tHeader, filterVal, this.loadDataToExportCollection);
      this.$messageSuccess(
        this.filter.paymentMethod === "Thu tiền mặt"
          ? "Xuất phiếu thu tiền mặt"
          : "Xuất phiếu thu chuyển khoản"
      );
    },

    async exportExcel() {
      if (this.pageMode === "Báo cáo thu") {
        this.exportCollection();
      } else {
        this.$store.dispatch("FLAG_LOADING", true);
        const tHeader = Object.values(this.AllFieldDataBill);
        const filterVal = Object.keys(this.AllFieldDataBill);
        this.listBill = [];
        await this.getData();
        let exportData = this.loadDataToExport();
        this.$exportExcel(tHeader, filterVal, exportData);
        this.$store.dispatch("FLAG_LOADING", false);
        this.$messageSuccess("Xuất excel thành công");
        // this.$set(this.forms, "utilities", "");
      }
    },

    async getData(lastData, firstData, limit) {
      this.$store.dispatch("FLAG_LOADING", true);
      this.isShowBill = false;
      let bits = localStorage.getItem("bits");
      let query = this.db
        .collection(process.env.VUE_APP_ORDER + bits)
        .where(
          "isPayment",
          "==",
          this.pageMode === "Báo cáo xuất hàng" ? false : true
        );
      if (this.filter.startDate !== null) {
        query = query.where("orderDate", ">=", this.filter.startDate.valueOf());
      }
      if (this.filter.endDate !== null) {
        query = query.where(
          "orderDate",
          "<=",
          new Date().setDate(this.filter.endDate.getDate() + 1).valueOf()
        );
      }
      if (this.pageMode === "Báo cáo thu") {
        query = query.where("paymentMethod", "==", this.filter.paymentMethod);
      }
      if (this.filter.status != -1 && this.pageMode === "Báo cáo xuất hàng") {
        query = query.where("status", "==", this.filter.status);
      }
      if (this.filter.salerName != "") {
        query = query.where("salerName", "==", this.filter.salerName);
      }
      if (this.filter.customerName != "") {
        query = query.where("customerName", "==", this.filter.customerName);
      }

      query = query.orderBy("orderDate", "desc");
      if (limit) {
        query = query.limit(limit);
      }
      if (lastData) {
        let docRef = this.db
          .collection(process.env.VUE_APP_ORDER + bits)
          .doc(lastData);
        let snapshot = await docRef.get();
        query = query.startAfter(snapshot);
      }
      if (firstData) {
        let docRef = this.db
          .collection(process.env.VUE_APP_ORDER + bits)
          .doc(firstData);
        let snapshot = await docRef.get();
        query = query.endBefore(snapshot);
      }
      //this.$store.dispatch("FLAG_LOADING", true);
      await query.get().then((doc) => {
        // this.listBill = [];
        doc.forEach((item) => {
          this.listBill.push({
            id: item.id,
            data: item.data(),
          });
        });
        this.$store.dispatch("FLAG_LOADING", false);
      });
      this.listBill.sort((a, b) =>
        a.data.orderDate > b.data.orderDate
          ? -1
          : b.data.orderDate > a.data.orderDate
          ? 1
          : 0
      );
    },

    close(id) {
      this.billSelected = {};
      this.isShowBill = false;
      this.isAddBill = false;
      this.$store.dispatch("FLAG_LOADING", true);
      var bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_ORDER + bits)
        .doc(id)
        .get()
        .then((res) => {
          if (res.exists) {
            console.log(res.data());
            var index = this.listBill.findIndex((el) => {
              return el.id === id;
            });
            this.listBill[index].data = {};
            this.listBill[index].data = res.data();
            this.$store.dispatch("FLAG_LOADING", false);
          }
        });
      // this.startFilter()
    },

    addBillClose() {
      this.billSelected = {};
      this.isShowBill = false;
      this.isAddBill = false;
      this.startFilter();
    },

    loadDataToExport() {
      let list = [];
      this.listBill.forEach((item) => {
        item.data.cartItems.forEach((cartItem) => {
          list.push({
            viewInNote: "",
            saleMethods: 0,
            paymentMethod: item.data.paymentMethod,
            warehouseReceipt: 1,
            lapKemHoaDon: 0,
            daLapHoaDon: 0,
            ngayHachToan: this.formatDate(
              new Date(item.data.orderDate)
            ).substring(0, 11),
            ngayChungTu: this.formatDate(
              new Date(item.data.orderDate)
            ).substring(0, 11),
            soChungTu: item.data.orderId,
            soPhieuXuat: "XK" + item.data.orderId,
            lyDoXuat: "Xuất kho bán hàng " + item.data.customerName,
            mauSoHĐ: "",
            kyHieuHĐ: "",
            soHoaDon: "",
            ngayHoaDon: "",
            maKhachHang: item.data.customerCode,
            tenKhachHang: item.data.customerName,
            diaChi: "",
            maSoThue: "",
            dienGiai: "Bán hàng " + item.data.customerName,
            nopVaoTK: "",
            nhanVienBanHang: item.data.salerCode,
            loaiTien: "",
            tyGia: "",
            maHang: cartItem.productId,
            tenHang: cartItem.productName,
            hangKhuyenMai: "",
            TKTienChiPhiNo: 131,
            TKDoanhThuCo: 5111,
            ĐVT: cartItem.unit,
            soLuong: cartItem.number,
            donGiaSauThue:
              parseInt(cartItem.productCost) * (1 + parseFloat(item.data.vat)),
            donGia: cartItem.productCost,
            thanhTien: cartItem.amount,
            thanhTienQuyDoi: "",
            tyLeChietKhau:
              cartItem.discountValue == 0 ? "" : cartItem.discountValue,
            tienChietKhau:
              cartItem.discountAmount == 0 ? "" : cartItem.discountAmount,
            tienChietKhauQuyDoi: "",
            TKChietKhau: 5111,
            giaTinhThueXK: "",
            phanTramthueXK: "",
            tienThueXK: "",
            TKThueXK: "",
            phanTramThueGTGT: item.data.vat, // vat?
            tienThueGTGT: item.data.vatAmount,
            tienThueGTGTQuyDoi: "",
            TKThueGTGT: "",
            HHKhongTHTrenToKhaiThue: "",
            kho: "Chưa làm",
            TKGiaVon: 632,
            TKKho: 1561,
            donGiaVon: "",
            tienVon: "",
            hangHoaGiuHoBanHo: "",
          });
        });
      });
      return list;
    },
  },

  computed: {
    filterChangeTrigger() {
      return (
        this.filter.startDate +
        this.filter.endDate +
        this.filter.status +
        this.filter.paymentMethod
      );
    },

    paginationClass() {
      return `pagination-${this.type}`;
    },
    ...mapGetters(["notifications"]),

    loadDataToExportCollection() {
      let list = [];
      this.filter.paymentMethod === "Thu tiền mặt"
        ? this.listBill.forEach((item) => {
            list.push({
              hienThiTrenSo: "",
              ngayHachToan: this.formatDate(
                new Date(item.data.orderDate)
              ).substring(0, 11),
              ngayChungTu: this.formatDate(
                new Date(item.data.orderDate)
              ).substring(0, 11),
              soChungTu: "",
              maDoiTuong: item.data.customerCode,
              tenDoiTuong: "",
              diaChi: "",
              nopVaoTK: item.data.accountPayment,
              moTaiNH: "",
              lyDoThu: 34,
              dienGiaiLyDoThu: item.data.reason,
              nhanVienThu: item.data.employeeCode,
              loaiTien: "",
              tyGia: "",
              dienGiai: item.data.reason,
              TKNo: 1121,
              TKCo: 131,
              soTien: item.data.amount * -1,
              soTienQuyDoi: "",
              doiTuong: item.data.customerCode,
              khoanMucCP: "",
              donVi: "",
              doiTuongTHCP: "",
              congTrinh: "",
              donDatHang: "",
              hopDongMua: "",
              hopDongBan: "",
              maThongKe: "",
            });
          })
        : this.listBill.forEach((item) => {
            list.push({
              hienThiTrenSo: "",
              ngayHachToan: this.formatDate(
                new Date(item.data.orderDate)
              ).substring(0, 11),
              ngayChungTu: this.formatDate(
                new Date(item.data.orderDate)
              ).substring(0, 11),
              soChungTu: "",
              maDoiTuong: item.data.customerCode,
              tenDoiTuong: "",
              diaChi: "",
              lyDoNop: 13,
              dienGiaiLyDoNop: item.data.reason,
              nguoiNop: "",
              nhanVienThu: item.data.employeeCode,
              kemTheo: "",
              loaiTien: "",
              tyGia: "",
              dienGiai: item.data.reason,
              TKNo: 1111,
              TKCo: 131,
              soTien: item.data.amount * -1,
              quyDoi: "",
              doiTuong: item.data.customerCode,
              TKNganHang: "",
            });
          });
      return list;
    },

    nextDate() {
      return this.formatDate(this.filter.date).replace("00:00:00", "23:59:59");
    },

    queriedData() {
      let result = this.listBill;
      return result.slice(this.from, this.to);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    total() {
      return this.listBill.length;
    },
  },
  watch: {
    filterChangeTrigger(value) {
      //console.log(value);
      if (
        (this.filter.startDate != null &&
          this.filter.startDate.getHours() +
            this.filter.startDate.getMinutes() +
            this.filter.startDate.getSeconds() !=
            0) ||
        (this.filter.endDate != null &&
          this.filter.endDate.getHours() +
            this.filter.endDate.getMinutes() +
            this.filter.endDate.getSeconds() !=
            0)
      ) {
        return;
      } else this.startFilter();
    },

    "pagination.currentPage"() {
      if (this.pagination.currentPage >= this.total / this.pagination.perPage) {
        // if (this.listBill.length == 10) {
        this.getData(
          this.listBill[this.listBill.length - 1].id,
          null,
          this.pagination.perPage
        );
        // }
      }
    },

    pageMode() {
      // if (this.pageMode === "Báo cáo xuất hàng") {
      //   this.filter.status = 0;
      // } else this.filter.status = -1;
      this.startFilter();
    },

    "filter.salerName"(value) {
      if (value === "") this.startFilter();
    },

    "filter.salerName"(value) {
      if (value === "") this.startFilter();
    },
  },

  beforeDestroy() {
    this.$store.dispatch("LOAD_NOTIFICATIONS", {});
  },
};
</script>
<style lang="scss" scoped>
.tableFooter {
  padding: 10px !important;
}

.table_success {
  background-color: rgba(253, 255, 132, 0.336);
}
.table-border {
  border: solid rgba(0, 0, 0, 0.178) 1px;
  border-radius: 10px;
}
.export-excel {
  display: flex;
  justify-content: center;
  position: absolute;
  align-items: center;
  top: 5px;
  right: 20px;
}
.danger {
  background-color: rgba(253, 207, 207, 0.979);
}
.done {
  background-color: rgba(200, 253, 200, 0.979);
}
.shipping {
  background-color: rgba(223, 234, 255, 0.993);
}
.success {
  background-color: rgba(255, 240, 209, 0.993);
}

.table-cell-money {
  color: red;
  text-align: right;
}

.buttonAddBill {
  display: inline-block;
  margin-right: 20px;
}
</style>
